import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import ptLocale from '@fullcalendar/core/locales/pt';
import Swal from 'sweetalert2';
import Loader from '../../Loader/Loader';
import { getTokenInfo } from '../../../UseToken';
import Hosts from '../../../Hosts';
import { reqGET, reqPOST, reqPUT, simpleAxiosGet } from '../../../Utils';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { icon } from '../../WEBContent/Icon';
import { color } from '../../WEBContent/Color';
import { language } from '../../WEBContent/Language';
import { tr } from 'date-fns/locale';

export default function CalendarView() {
  const [isLoading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [lang, set_lang] = useState('pt');

  const today = new Date();
  const fifteenth = new Date(today.getFullYear(), today.getMonth(), 15);
  const [year_active_calendar, set_year_active_calendar] = useState(fifteenth.getFullYear());

  const [tasks, setTasks] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [content, setContent] = useState([]);

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const [visibleTasks, setVisibleTasks] = useState([]);
  const [futureTasks, setFutureTasks] = useState([]);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [eventTitle, setEventTitle] = useState('');
  const [eventTime, setEventTime] = useState("09:00");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [eventDescription, setEventDescription] = useState("");
  const [eventLocation, setEventLocation] = useState("");
  const [feriados, setFeriados] = useState([]);

  const handleRowClick = (id) => {
    document.getElementById("c_" + id)?.click();
  };

  const handleRowEventClick = (id) => {
    console.log('handleRowEventClick id', id)
    console.log('document.getElementById("ce_' + id + '")?.click();')
    document.getElementById("ce_" + id)?.click();
  };

  const handleRowTaskClick = (id) => {
    console.log('handleRowTaskClick id', id)
    console.log('document.getElementById("ct_' + id + '")?.click();')
    document.getElementById("ct_" + id)?.click();
  };

  const priorityColors = {
    normal: color.corNormal.hexa,
    naoUrgente: color.corNaoUrgente.rgb,
    poucoUrgente: color.corPoucoUrgente.rgb,
    urgente: color.corUrgente.hexa,
    critica: color.corCritica.rgb
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case '1': return priorityColors.normal;
      case '2': return priorityColors.naoUrgente;
      case '3': return priorityColors.poucoUrgente;
      case '4': return priorityColors.urgente;
      case '5': return priorityColors.critica;
      default: return 'rgb(128, 128, 128)';
    }
  };

  const getEstadoStyle = (estado, lang) => {
    const estadoLabel = lang === 'en' ? estado.labelEn : estado.labelPt;

    switch (estadoLabel) {
      case 'Concluído':
      case 'Completed':
        return { color: color.corVerde.rgb, fontWeight: '600' }; // Verde
      case 'Em Progresso':
      case 'In Progress':
        return { color: color.corNormal.rgb, fontWeight: '600' }; // Azul
      case 'Em Execução':
      case 'In execution':
        return { color: color.corUrgente.rgb, fontWeight: '600' }; // Laranja
      case 'Pendente':
      case 'Pending':
        return { color: color.corCritica.rgb, fontWeight: '600' }; // Vermelho
      case 'A Iniciar':
      case 'To Start':
        return { color: color.corAmarela.rgb3, fontWeight: '600' }; // Amarelo
      case 'Em Revisão':
      case 'Under Review':
        return { color: color.corRoxa.rgb, fontWeight: '600' }; // Roxo
      case 'Cancelado':
      case 'Canceled':
        return { color: color.corVermelha.rgb, fontWeight: '600' }; // Cinza
      default:
        return { color: color.cor4.rgb, fontWeight: '600' }; // Cinza Claro
    }
  };

  const calendarStyles = `
  .fc {
    width: 100%;
    border: none;
    font-size: 1.05rem;
  }

  /* Make weekends stand out */
  .fc-day-sun, .fc-day-sat {
    background-color: #f9f9f9; 
  }

  .fc-day-sun .fc-daygrid-day-number,
  .fc-day-sat .fc-daygrid-day-number {
    color: #ff6666; 
    font-weight: 600;
  }

  /* Today’s highlight */
  .fc-day-today {
    background-color: #fff8e1 !important; 
    border: 2px solid #f9a825 !important;
  }

  /* Buttons (toolbar) */
  .fc .fc-button {
    background-color: #191C32 !important;
    color: #fff !important;
    border-radius: 8px;
    transition: background 0.2s ease;
    border: none !important;
    font-weight: normal !important;
  }

  .fc .fc-button:hover {
    background-color: #2b3060 !important;
  }

  .fc-daygrid-day-has-event .fc-daygrid-day-frame:hover {
  background-color: #e3f2fd !important;
  cursor: pointer;
  }

  .fc-event {
    border: none !important;
    border-radius: 6px;
    padding: 2px 4px;
    font-size: 0.85rem;
  }

  .fc-day-holiday {
    background-color: #ffe0e0 !important;
    border: 1px solid #f5b7b1 !important;
  }

  .fc-daygrid-day:not(.fc-daygrid-day-has-event)
  .fc-daygrid-day-frame {
    pointer-events: auto;
  }

  .fc-daygrid-day:not(.fc-daygrid-day-has-event)
  .fc-daygrid-day-frame:hover {
    background-color: #e3f2fd;
    cursor: pointer;
  }

  .fc-daygrid-day:not(.fc-daygrid-day-has-event)
    .fc-daygrid-day-top {
    pointer-events: auto;
    cursor: pointer;
    display: inline-flex;
    padding: 4px 6px;
    border-radius: 6px;
  }

  .fc-daygrid-day:not(.fc-daygrid-day-has-event)
    .fc-daygrid-day-top:hover {
    background-color: #e3f2fd;
  }
  `;

  useEffect(() => {
    if (!year_active_calendar) return;

    const loadHolidays = async () => {
      try {
        const holidayResponse = await simpleAxiosGet(
          "https://services.sapo.pt",
          `/Holiday/GetNationalHolidays?year=${year_active_calendar}`
        );

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(holidayResponse, "text/xml");
        const holidayNodes = xmlDoc.getElementsByTagName("Holiday");

        const feriadosParsed = Array.from(holidayNodes).map((node) => ({
          name: node.getElementsByTagName("Name")[0]?.textContent || "",
          date: formatDate(new Date(node.getElementsByTagName("Date")[0]?.textContent)),
        }));

        setFeriados(feriadosParsed);
      } catch (error) {
        console.error("Erro ao buscar feriados:", error);
      }
    };

    loadHolidays();
  }, [year_active_calendar]);

  const isFeriado = (date) => {
    const formatted = formatDate(date);
    return feriados.some((f) => f.date === formatted);
  };

  const isWeekend = (date) => {
    const day = date.getDay();
    return day === 0 || day === 6;
  };

  const formatDate = (d) => {
    if (!d) return null;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const buildLocalDateTime = (date, time) => {
    if (!date) return null;

    const d = new Date(date);
    if (time) {
      const [h, m] = time.split(":").map(Number);
      d.setHours(h, m, 0, 0);
    }
    return d;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        set_lang(localStorage.getItem("lang"));
        const storedData = localStorage.getItem("token");
        if (!storedData) return;
        const data = JSON.parse(storedData);
        if (!data.user_info) return;

        const userId = data.user_info.id;
        setUserId(userId);
        setLoading(true);

        const [tarefaResponse, ticketResponse, eventoResponse] = await Promise.all([
          reqGET(`${Hosts.SIMCore_API}/tarefa/${getTokenInfo().companycode}`),
          reqGET(`${Hosts.SIMCore_API}/intranet/suporte/${getTokenInfo().companycode}`),
          reqGET(`${Hosts.SIMCore_API}/evento/type/${getTokenInfo().companycode}/evento`),
        ]);

        const userTasks = tarefaResponse.data.filter(
          (task) =>
            Array.isArray(task.info.responsaveis) &&
            task.info.responsaveis.some((r) => r.value === userId) &&
            task.info?.estado?.value !== 2 // && task.info?.estado?.value !== 6
        );

        //console.log('userTasks', userTasks);

        const formattedTasks = userTasks
          .map((task) => ({
            id: task.id,
            title: task.info.name || "Sem título",
            color: getPriorityColor(task.info.prioridade?.value),
            extendedProps: {
              ...task.info,
              data_inicio: task.info.data_inicio,
              data_limite: task.info.data_limite,
              dataConclusao: task.info.dataConclusao,
            },
            type: "tarefa",
          }));

        const userTickets = (ticketResponse?.data || [])
          .filter(
            (ticket) => ticket.info?.colaborador?.[0]?.value === userId
          );

        //console.log('userTickets', userTickets);

        const formattedTickets = userTickets.map((ticket) => ({
          id: `ticket-${ticket.id}`,
          title: ticket.info.assunto || "Ticket sem assunto",
          color: color.corAmarela.hexa3,
          extendedProps: ticket.info,
          type: "ticket",
        }));

        const userEventos = (eventoResponse?.data || []).filter((evento) => {
          const responsaveis = evento.info?.responsaveis || [];
          const isLembrete = evento.info?.event_type?.name === "Lembrete";

          const isResponsavel =
            responsaveis.some((p) => String(p.id) === String(userId));

          const creatorId =
            Array.isArray(evento?.info?.createadBy) &&
            evento.info?.createadBy.some((c) => String(c.id) === String(userId));

          if (isLembrete) {
            return creatorId;
          }

          return responsaveis.length === 0 || isResponsavel;
        });

        const eventos = userEventos.map((evento) => ({
          id: `evento-${evento.id}`,
          title: evento.info?.title?.[0]?.pt || evento.info?.name || "Evento",
          type: "evento",
          color: color.corVerde.hexa3,
          start: buildLocalDateTime(evento.info.date, evento.info.time),
          allDay: false,
          extendedProps: evento.info,
        }));

        const content = [
          ...formattedTasks,
          ...formattedTickets,
          ...eventos,
        ];

        setTasks(formattedTasks);
        setTickets(formattedTickets);
        setEventos(eventos);
        setContent(content);

      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        Swal.fire({
          title: "Erro",
          text: "Não foi possível carregar os dados",
          icon: "error",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, [selectedDate]);

  // ---------------- EVENT CLICK HANDLER ----------------
  const handleClick = (info) => {
    const event = info.event;
    const type = event.extendedProps?.type || event._def?.extendedProps?.type;

    if (type === "tarefa") {
      taskDetails(event);
    } else if (type === "ticket") {
      ticketDetails(event);
    } else if (type === "evento") {
      eventDetails(event);
    } else {
      Swal.fire({
        title: event.title || "Detalhes",
        text: "Não foi possível identificar o tipo deste evento.",
        width: "650px",
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: true,
      });
    }
  };

  // ---------------- EVENTOS ----------------
  const eventDetails = (event) => {
    setSelectedEvent(event);

    const formatDate = (date) =>
      date
        ? new Date(date).toLocaleDateString(
          lang === "pt" ? "pt-PT" : "en-US",
          { dateStyle: "full" }
        )
        : null;

    const details = [
      {
        label: lang === "pt" ? "Título" : "Title",
        value: event.extendedProps?.title?.[0]?.pt || event.extendedProps?.name || "—",
      },
      {
        label: lang === "pt" ? "Tipo de Evento" : "Event Type",
        value: event.extendedProps?.event_type?.name || "—",
      },
      {
        label: lang === "pt" ? "Data" : "Date",
        value: formatDate(event.extendedProps?.date),
      },
      {
        label: lang === "pt" ? "Hora" : "Time",
        value: event.extendedProps?.time || (lang === "pt" ? "Dia todo" : "All day"),
      },
      {
        label: lang === "pt" ? "Localização" : "Location",
        value: event.extendedProps?.location || "—",
      },
      {
        label: lang === "pt" ? "Prioridade" : "Priority",
        value: event.extendedProps?.prioridade || "—",
      },
      {
        label: lang === "pt" ? "Descrição" : "Description",
        value: Array.isArray(event.extendedProps?.description)
          ? event.extendedProps.description.map((d) => d.pt || d.en).join("<br/>")
          : event.extendedProps?.description || "—",
      },
    ];

    Swal.fire({
      title: `
      <div style="display:flex; justify-content:center; align-items:center; gap:12px;">
        <h2 style="font-size:1.5rem; font-weight:600; margin:0;">
          ${event.title} 
        </h2> 
      </div>
    `,
      html: `
      <div style="text-align:left; font-size:1rem; line-height:1.5;">
        ${details
          .filter((d) => d.value)
          .map(
            (d) =>
              `<p style="margin:0.3rem 0;">
                 <b>${d.label}:</b> ${d.value}
               </p>`
          )
          .join("")}
      </div>
      <div style="margin-top:1.5rem; display:flex; justify-content:center; gap:12px;">
        <button id="backBtn" class="btn btn-light">
          <i class="bi bi-arrow-left"></i> ${language[lang].back}
        </button>
        <button id="goToEvent" class="btn btn-primary">
          <i class="bi bi-eye"></i> ${language[lang].view}
        </button>
      </div>
    `,
      width: "650px",
      showCloseButton: true,
      showConfirmButton: false,
      backdrop: true,
      didOpen: () => {
        document
          .getElementById("backBtn")
          .addEventListener("click", () => Swal.close());

        document
          .getElementById("goToEvent")
          .addEventListener("click", () => {
            Swal.close();
            handleRowEventClick(event.id);
          });
      },
    });
  };

  const handleCreateEvent = async () => {
    const aux = {
      id: '',
      info: {
        active: true,
        avaiable: false,
        companycode: "2024000",
        createadBy: [
          {
            id: userId,
            timestamp: new Date().toISOString(),
          },
        ],
        date: selectedDate,
        departamento: null,
        departamentoGrupo: null,
        description: [{
          pt: eventDescription,
        },
        ],
        event_type: {
          id: 0,
          name: lang === "pt" ? "Lembrete" : "Reminder",
          poll_active: false,
          select_colab: false,
        },
        grupo: null,
        image: {},
        isLocked: false,
        location: eventLocation,
        name: eventTitle,
        order: 0,
        poll: [],
        prioridade: "Normal",
        responsaveis: [],
        time: eventTime,
        title: [{
          pt: eventTitle,
        }],
        type: "evento",
        unique_code: Date.now().toString(),
        visibilidade: false,
        votacao: false,
        votacao_oculta: false,
      },
    };

    try {
      const res = await reqPOST(`${api_crud_base}/evento`, aux);
      console.log(res);

    } catch (err) {
      console.error(err);

    } finally {
      setShowCreateModal(false);
      window.location.reload();
    }

  };

  // ---------------- TAREFAS ----------------
  const taskDetails = (task) => {
    setSelectedTask(task);

    const formatDate = (date) =>
      date
        ? new Date(date).toLocaleDateString(
          lang === "pt" ? "pt-PT" : "en-US",
          { dateStyle: "full" }
        )
        : null;

    const estado = task.extendedProps?.estado;
    const estadoLabel =
      lang === "en" ? estado?.labelEn || "—" : estado?.labelPt || "—";
    const estadoStyle = estado ? getEstadoStyle(estado, lang) : {};

    const details = [
      {
        label: lang === "pt" ? "Tipo" : "Type",
        value:
          task.type ||
          task.extendedProps?.type ||
          (lang === "pt" ? "Não definido" : "Undefined"),
      },
      {
        label: lang === "pt" ? "Início" : "Start",
        value: formatDate(task.extendedProps?.data_inicio),
      },
      ...(task.extendedProps?.data_limite
        ? [
          {
            label: lang === "pt" ? "Fim" : "End",
            value: formatDate(task.extendedProps?.data_limite),
          },
        ]
        : []),
      {
        label: lang === "pt" ? "Descrição" : "Description",
        value:
          task.description ||
          task.extendedProps?.description ||
          (lang === "pt" ? "Nenhuma descrição" : "No description"),
      },
    ];

    Swal.fire({
      title: `
      <div style="display:flex; justify-content:center; align-items:center; gap:12px;">
        <h2 style="font-size:1.5rem; font-weight:600; margin:0;">
          ${task.title} 
        </h2>    
        -   
        <span style="font-size:1.5rem; font-weight:600; margin:0; color:${estadoStyle.color};">
          ${estadoLabel}
        </span>
      </div>
    `,
      html: `
      <div style="text-align:left; font-size:1rem; line-height:1.5;">
        ${details
          .filter((d) => d.value)
          .map(
            (d) =>
              `<p style="margin:0.3rem 0;">
                 <b>${d.label}:</b> ${d.value}
               </p>`
          )
          .join("")}
      </div>
      <div style="
        margin-top:1.5rem; 
        display:flex; 
        justify-content:center; 
        gap:12px;
      ">
        <button id="backBtn" class="btn btn-light">
          <i class="bi bi-arrow-left"></i> ${language[lang].back}
        </button>

        <button id="goToTask" class="btn btn-secondary">
          <i class="bi bi-eye"></i> ${language[lang].view}
        </button>
      </div>
    `,
      width: "650px",
      showCloseButton: true,
      showConfirmButton: false,
      backdrop: true,
      didOpen: () => {
        document
          .getElementById("backBtn")
          .addEventListener("click", () => Swal.close());

        document
          .getElementById("goToTask")
          .addEventListener("click", () => {
            Swal.close();
            console.log(task.id);
            handleRowTaskClick(task.id);
          });
      },
    });
  };

  // ---------------- TICKETS ----------------
  const ticketDetails = (ticket) => {
    setSelectedTicket(ticket);

    const formatDate = (date) =>
      date
        ? new Date(date).toLocaleDateString(
          lang === "pt" ? "pt-PT" : "en-US",
          { dateStyle: "full" }
        )
        : null;

    const details = [
      {
        label: lang === "pt" ? "Título" : "Title",
        value:
          ticket.title ||
          ticket.extendedProps?.name ||
          (lang === "pt" ? "Sem título" : "No title"),
      },
      {
        label: lang === "pt" ? "Tipo" : "Type",
        value:
          ticket.type ||
          ticket.extendedProps?.type ||
          (lang === "pt" ? "Não definido" : "Undefined"),
      },
      {
        label: lang === "pt" ? "Departamento" : "Department",
        value:
          ticket.extendedProps?.departamentoGrupo ||
          ticket.extendedProps?.departamento ||
          "—",
      },
      {
        label: lang === "pt" ? "Estado" : "Status",
        value: ticket.extendedProps?.estado || (lang === "pt" ? "Aberto" : "Open"),
      },
      {
        label: lang === "pt" ? "Data" : "Date",
        value: formatDate(ticket.extendedProps?.date),
      },
      {
        label: lang === "pt" ? "Descrição" : "Description",
        value: Array.isArray(ticket.extendedProps?.description)
          ? ticket.extendedProps.description.map((d) => d.pt || d.en).join("<br/>")
          : ticket.extendedProps?.description || "—",
      },
    ];

    Swal.fire({
      title: `
      <h2 style="font-size:1.5rem; font-weight:600; margin:0; color:${ticket.color};">
        ${ticket.title || ticket.extendedProps?.name}
      </h2>
    `,
      html: `
      <div style="text-align:left; font-size:1rem; line-height:1.5;">
        ${details
          .filter((d) => d.value)
          .map(
            (d) =>
              `<p style="margin:0.3rem 0;">
                 <b>${d.label}:</b> ${d.value}
               </p>`
          )
          .join("")}
      </div>
      <div style="margin-top:1.5rem; display:flex; justify-content:center; gap:12px;">
        <button id="backBtn" class="btn btn-light">
          <i class="bi bi-arrow-left"></i> ${language[lang].back}
        </button>
        <button id="goToTicket" class="btn btn-success">
          <i class="bi bi-eye"></i> ${language[lang].view}
        </button>
      </div>
    `,
      width: "650px",
      showCloseButton: true,
      showConfirmButton: false,
      backdrop: true,
      didOpen: () => {
        document
          .getElementById("backBtn")
          .addEventListener("click", () => Swal.close());

        document
          .getElementById("goToTicket")
          .addEventListener("click", () => {
            Swal.close();
            handleRowClick(ticket.id);
          });
      },
    });
  };

  const eventAllow = (dropInfo, draggedEvent) => {
    const type = draggedEvent.extendedProps?.type;
    return type === "evento";
  };

  const eventDrop = async (info) => {
    const { event } = info;
    const type = event.extendedProps?.type;

    if (type !== "evento") {
      info.revert();
      return;
    }

    const realId = event.id.replace("evento-", "");
    const localDate = event.start;
    const y = localDate.getFullYear();
    const m = String(localDate.getMonth() + 1).padStart(2, "0");
    const d = String(localDate.getDate()).padStart(2, "0");
    const finalDateStr = `${y}-${m}-${d}`;
    const originalTime = event.extendedProps?.time || null;

    const aux = {
      id: realId,
      info: {
        ...event.extendedProps,
        date: finalDateStr,
        time: originalTime,
        name: event.title,
        title: [{ pt: event.title }],
      },
    };

    try {
      await reqPUT(`${api_crud_base}/evento/${realId}`, aux);
    } catch (err) {
      console.error(err);
      info.revert();
    }
  };

  if (isLoading) return <Loader />;

  return (
    <main id="calendar-view" className="py-5">
      <div className="container-fluid">
        <div className="row justify-content-center gy-4 mb-4">
          <div className="col-12 col-lg-10">
            <div className="bg-white rounded-2xl shadow-sm p-4">
              {(() => {

                return (
                  <>
                    <style>{calendarStyles}</style>

                    {feriados.length === 0 ? (
                      <Loader />
                    ) : (

                      <FullCalendar
                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
                        editable={true}
                        eventStartEditable={true}
                        eventDurationEditable={false}
                        eventAllow={eventAllow}
                        eventDrop={eventDrop}
                        initialView="dayGridMonth"
                        eventTimeFormat={{
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: false
                        }}
                        initialDate={new Date(new Date().getFullYear(), new Date().getMonth(), 15)}
                        weekends={true}
                        firstDay={0}
                        locale={lang === "pt" ? ptLocale : "en"}
                        headerToolbar={{
                          left: "prev,next today",
                          center: "title",
                          right: "listWeek dayGridMonth,timeGridWeek,timeGridDay",
                        }}

                        datesSet={(info) => {
                          const fifteenth = new Date(info.start.getFullYear(), info.start.getMonth(), 15);
                          const yearOfFifteenth = fifteenth.getFullYear();
                          if (yearOfFifteenth !== year_active_calendar) {
                            set_year_active_calendar(yearOfFifteenth);
                          }
                        }}
                        snapDuration={{ days: 1 }}
                        dragScroll={false}
                        dateClick={(info) => {
                          const clickedDate = info.date;

                          if (isWeekend(clickedDate) || isFeriado(clickedDate)) {
                            Swal.fire({
                              icon: "warning",
                              title: lang === "pt" ? "Data inválida" : "Invalid date",
                              text:
                                lang === "pt"
                                  ? "Não é possível criar eventos em fins de semana ou feriados."
                                  : "You cannot create events on weekends or holidays.",
                            });
                            return;
                          }

                          setSelectedDate(formatDate(clickedDate));
                          setShowCreateModal(true);
                        }}

                        viewDidMount={() => {
                          console.log("Today's date:", new Date());
                        }}

                        events={content
                          .map((item) => {

                            const date =
                              item.extendedProps?.data_inicio ||
                              item.extendedProps?.date ||
                              item.extendedProps?.data_limite ||
                              item.extendedProps?.dataConclusao;

                            const endDate =
                              item.type === "tarefa"
                                ? item.extendedProps?.data_limite ||
                                item.extendedProps?.dataConclusao
                                : null;

                            const time = item.extendedProps?.time;

                            let start;

                            if (date && time) {
                              start = new Date(`${date}T${time}`);
                            } else if (date) {
                              start = new Date(date);
                            }

                            const isFeriado = feriados.some(
                              (f) => f.date === formatDate(start)
                            );
                            const weekend = isWeekend(start);

                            if (
                              (item.type === "tarefa" ||
                                item.type === "ticket") &&
                              (isFeriado || weekend)
                            ) {
                              return null;
                            }

                            const title =
                              typeof item.title === "string"
                                ? item.title
                                : item.title?.[0]?.pt ||
                                item.title?.[0]?.en ||
                                "Sem título";

                            let color = item.color;
                            let icon = "bi bi-circle";

                            switch (item.type) {
                              case "evento":
                                color = "#28a745";
                                icon = "bi bi-calendar-event";
                                break;
                              case "ticket":
                                color = "#CCAE57";
                                icon = "bi bi-ticket-detailed";
                                break;
                              case "tarefa":
                                const prioridade =
                                  item.extendedProps?.prioridade?.value;
                                color = getPriorityColor(prioridade);
                                icon = "bi bi-check-circle";
                                break;
                              default:
                                color = color || "#6c757d";
                            }

                            return {
                              ...item,
                              title,
                              start,
                              end: endDate ? new Date(endDate) : null,
                              allDay: !time,
                              backgroundColor: color,
                              textColor:
                                item.type === "ticket" ? "#222" : "#fff",
                              borderColor: color,
                              extendedProps: {
                                ...item.extendedProps,
                                icon,
                                type: item.type,
                              },
                            };
                          })
                          .filter(Boolean)}

                        eventClick={handleClick}
                        eventBorderColor="transparent"
                        eventContent={(eventInfo) => {
                          const { event } = eventInfo;
                          const iconClass =
                            event.extendedProps.icon ||
                            "bi bi-circle";
                          return (
                            <div
                              className="text-sm fw-semibold px-1 py-0.5"
                              style={{
                                display: "inline-flex",
                                backgroundColor: event.backgroundColor,
                                color: event.textColor,
                                borderRadius: "5px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",

                                minHeight: "22px",
                                lineHeight: "1.2",
                                cursor: "pointer",
                                pointerEvents: "auto",
                              }}
                            >
                              <i
                                className={`${iconClass}`}
                                style={{
                                  fontSize: "0.9rem",
                                  flexShrink: 0,
                                }}
                              ></i>
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "block",
                                  flexGrow: 1,
                                }}
                                title={event.title}
                              >
                                {event.title}
                              </span>
                            </div>
                          );
                        }}

                        height="auto"
                        nowIndicator={true}
                        eventDisplay="auto"
                        eventMinHeight={18}
                        eventShortHeight={18}
                        dayMaxEvents={3}
                        moreLinkContent={(args) =>
                          `+${args.num} restantes`
                        }
                        moreLinkClick="popover"

                        dayCellDidMount={(info) => {
                          const dateStr = formatDate(info.date);
                          const feriado = feriados.find(
                            (f) => f.date === dateStr
                          );
                          const weekend = isWeekend(info.date);

                          if (feriado) {
                            info.el.style.backgroundColor = "#ffe5e5";
                            info.el.style.position = "relative";
                            const label = document.createElement("span");
                            label.innerText = feriado.name;
                            label.style.position = "absolute";
                            label.style.bottom = "4px";
                            label.style.left = "4px";
                            label.style.fontSize = "0.7rem";
                            label.style.color = "#d32f2f";
                            label.style.fontWeight = "600";
                            info.el.appendChild(label);
                          } else if (weekend) {
                            info.el.style.backgroundColor = "#f0f0f0";
                          }
                        }}
                      />
                    )}

                  </>
                );

              })()}

              {selectedTicket && (
                <Link
                  id={`c_${selectedTicket.id}`}
                  className="d-none"
                  to={{
                    pathname: "ticket_regist",
                    state: {
                      item: selectedTicket,
                      operation: "regist",
                    },
                  }}
                  replace
                >
                  <i className="bi bi-eye"></i>
                </Link>
              )}

              {showCreateModal && (
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="createEventModalLabel"
                  aria-modal="true"
                  style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
                >
                  <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content rounded-3 shadow">
                      <div className="modal-header">
                        <h5 className="modal-title" id="createEventModalLabel">
                          {lang === "pt" ? "Criar novo evento" : "Create New Event"}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          onClick={() => setShowCreateModal(false)}
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            {lang === "pt" ? "Título" : "Title"}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={eventTitle}
                            onChange={(e) => setEventTitle(e.target.value)}
                            placeholder={lang === "pt" ? "Nome do evento" : "Event title"}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            {lang === "pt" ? "Descrição" : "Description"}
                          </label>
                          <textarea
                            className="form-control"
                            rows={3}
                            value={eventDescription}
                            onChange={(e) => setEventDescription(e.target.value)}
                            placeholder={lang === "pt" ? "Descrição do evento" : "Event description"}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            {lang === "pt" ? "Data" : "Date"}
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            {lang === "pt" ? "Hora" : "Time"}
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            value={eventTime}
                            onChange={(e) => setEventTime(e.target.value)}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            {lang === "pt" ? "Localização" : "Location"}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={eventLocation}
                            onChange={(e) => setEventLocation(e.target.value)}
                            placeholder={lang === "pt" ? "Local do evento" : "Event location"}
                          />
                        </div>
                      </div>

                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowCreateModal(false)}
                        >
                          {language[lang].cancel}
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleCreateEvent}
                        >
                          {lang === "pt" ? "Criar Lembrete" : "Make Reminder"}
                        </button>

                      </div>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </main>
  );
}